class Deferred {
    constructor(options) {
        this.status = "pending";
        this.value;
        this.resolve;
        this.reject;
        //Also store the status and value to expose to outside
        this.promise = new Promise((resolve,reject)=>{
            this.resolve = function (result) {
                this.status = "resolved";
                this.value = result;
                resolve(result);
            };
            this.reject = function (error) {
                this.status = "rejected";
                this.value = error;
                reject(error);
            };
        });
    }
}

let wait = function (delay) {
    return new Promise((resolve, reject) => setTimeout(() => resolve(), delay));
};

let waitUntilTrue = async function (checkIsTrue,options) {
    let defer = new Deferred();
    let count = 0;
    if (!options) options = {};
    //limit is number of seconds to wait
    const limit = options.limit || 10000;
    //delay is number of seconds between each check
    const delay = options.delay || 100;

    let countMax = limit/delay;

    //Check immediately also
    let isTrue = await checkIsTrue();
    if (isTrue) {
        defer.resolve();
        return defer.promise;
    }
    let myInterval = window.setInterval(async function () {
//        console.log(count);
        count++;
        if (count>countMax) {
            window.clearInterval(myInterval);
            return defer.reject('Deferred.waitUntilTrue() timed out.');
        }

        let isTrue = await checkIsTrue();
        if (isTrue) {
            window.clearInterval(myInterval);
            defer.resolve();
        }
    },delay);
    return defer.promise;
};

export {Deferred, wait, waitUntilTrue};